import { baseTheme } from "@asd/customer-portal-ui";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { Box, Card, Stack, Tooltip, Typography } from "@mui/material";

// Recreated default Azure pin for use with React component
const AzurePinIcon = ({ color = "#1a73aa", size = 24, text }: { color?: string; size?: number; text?: string }) => (
  <svg
    height={size}
    style={{ display: "inline-block", verticalAlign: "middle" }}
    viewBox="0 0 30 37"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 22 15 22s15-11.5 15-22c0-8.3-6.7-15-15-15z" fill={color} />
    {text ? (
      <text alignmentBaseline="middle" fill="white" fontFamily="Arial, sans-serif" fontWeight="bold" textAnchor="middle" x="15" y="17">
        {text}
      </text>
    ) : (
      <circle cx="15" cy="15" fill="white" r="5" />
    )}
  </svg>
);

const MapLegend = ({ markerColors }: { markerColors: any }) => (
  <Box
    sx={{
      position: "absolute",
      top: 5,
      left: 5,
      zIndex: 500,
    }}
  >
    <Card>
      <Box
        sx={{
          p: 2,
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          columnGap: 2,
          rowGap: 1,
        }}
      >
        <AzurePinIcon color={markerColors.serviceLocation} text="★" />
        <Typography>Service Address</Typography>
        <AzurePinIcon color={markerColors.providerBase} text="⏺" />
        <Typography>Provider</Typography>
        <AzurePinIcon color={markerColors.outOfBounds.base} text="⊘" />
        <Stack alignItems="center" direction="row" gap={1}>
          <Typography>Provider (out of range)</Typography>
          <Tooltip
            slotProps={{
              tooltip: {
                sx: {
                  ...baseTheme.components.MuiTooltip.defaultProps.slotProps.tooltip.sx,
                  maxWidth: 500,
                },
              },
            }}
            title="Service address is farther than Provider's willingness to travel"
          >
            <InfoOutlineIcon
              color="primary"
              sx={{
                cursor: "help",
              }}
            />
          </Tooltip>
        </Stack>
      </Box>
    </Card>
  </Box>
);

export default MapLegend;
